
import Component from '@modules/vue-class-component';
import { Emit, Prop } from '@modules/vue-property-decorator';
import CircleCheck from '@shared/components/form/circleCheck.vue';
import Popup from '@shared/components/popup/popup-v2.vue';
import { Settings } from '@shared/core/services/configService';
import { CrudService } from '@shared/core/services/crudService';
import Vue from 'vue';

@Component({
  components: {
    Popup,
    CircleCheck,
  },
})
export default class AddPlayerPopup extends Vue {
  @Prop({ required: true, default: [] }) private players!: any[];
  @Prop({ default: null }) private maxParticipants!: number|null;
  private readonly crudService: CrudService;
  private searchResults: any[] = [];
  private selectedPlayer: any = null; // TODO: add multiple players?
  private query: string = "";
  private searchError: string|null = null;

  constructor() {
    super();
    this.crudService = new CrudService();
  }

  private get freeSlots() {
    if (!this.maxParticipants) return [];
    return Array(this.maxParticipants - this.players.length).fill({name: this.$t('Free Place')});
  }

  private async search() {
    let url = `${Settings.HostName}/api/publiccustomers/list`;
    let data = await this.crudService.httpPost(url, this.query);

    if (data == null || data === undefined || data.ok === false) {
      this.searchError = this.$t("crash").toString();
      return;
    }

    this.searchResults = data.rowData;
    
    if (!this.searchResults?.length) {
      this.searchError = `${this.$t("No results found for")} ${this.query}`;
    }
  }

  private getImagePath(img: string) {
    if (img === null || img === undefined || img === "") {
      return this.$store.state.settings.Uploads + "/" + this.$store.state.settings.Mainlogo;
    }
    return this.$store.state.settings.Uploads + "/" + img;
  }

  @Emit('addPlayer')
  private addPlayer() {
    return this.selectedPlayer;
  }

  @Emit("close")
  private closePopup() { }
}
